import { toast } from 'sonner'

export function showApiSuccessToast(message: string) {
	toast.success(message)
}

export function showApiErrorToast(message: string) {
	toast.error(message)
}
